import { render, staticRenderFns } from "./RoomsLayout.vue?vue&type=template&id=0ee5c49e"
import script from "./RoomsLayout.vue?vue&type=script&lang=js"
export * from "./RoomsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports